import type { PropsWithChildren } from "react";
import { useRef, useState } from "react";

import type { IPopupWrapperProps } from "@similarweb/ui-components";
import { PopupClickContainerStateless } from "@similarweb/ui-components";

import ContentMediaQueryWrapper from "./ContentMediaQueryWrapper";
import { getTooltipConfig } from "./utils";

const APPEND_TO_SELECTOR = "body";

type Props = Pick<IPopupWrapperProps, "content"> & {
    isOpen: boolean;
    onClose?(isOutsideClick: boolean, e: MouseEvent): void;
};

const ColumnSuggestionsTooltipBase = ({ content: Content, children, isOpen, onClose }: PropsWithChildren<Props>) => {
    const [isVisible, setIsVisible] = useState(true);
    const triggerElementRef = useRef<HTMLDivElement | null>(null);

    const popupConfig = getTooltipConfig({ withLeftAlignment: !isVisible });

    const renderContent = () => (
        <ContentMediaQueryWrapper
            popupPlacement={popupConfig.placement}
            triggerElementRef={triggerElementRef}
            onVisibilityChange={setIsVisible}
        >
            <Content />
        </ContentMediaQueryWrapper>
    );

    return (
        <PopupClickContainerStateless
            isOpen={isOpen}
            content={renderContent}
            config={popupConfig}
            appendTo={APPEND_TO_SELECTOR}
            onClose={onClose}
        >
            {/* Outdated ref setup due to PopupClickContainerStateless implementation of immediate child ref */}
            <div
                ref={(node) => {
                    triggerElementRef.current = node;
                }}
            >
                {children}
            </div>
        </PopupClickContainerStateless>
    );
};

export default ColumnSuggestionsTooltipBase;
